import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {GeneralInfoItem} from "../types/generalInfo";

const COLLECTION_ID = "spostrada_info"

const databases = new Databases(client);

export const supCouncilInformationService = {

  async list(queries: string[] = [], limit: number = 100): Promise<GeneralInfoItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const items = response.documents.map(doc => doc as unknown as GeneralInfoItem);
      return items;
    } catch (error) {
      throw error;
    }
  },
  async getById(id: string): Promise<GeneralInfoItem> {
    try {
      const data = await databases.getDocument(
        database_id,
        COLLECTION_ID,
        id
      ) as unknown as GeneralInfoItem;
      return data
    } catch (error) {
      throw error;
    }
  },
  }